var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165576",
    "data-name": "\\uADF8\\uB8F9 165576",
    transform: "translate(-890 -450)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_164960",
    "data-name": "\\uADF8\\uB8F9 164960",
    transform: "translate(11624 4982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "free-animated-icon-work-in-progress-10282582",
    transform: "translate(-10732.322 -4545.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86537",
    "data-name": "\\uD328\\uC2A4 86537",
    d: "M203.111,235.965A11.774,11.774,0,0,1,191.35,224.2c.591-15.581,22.933-15.577,23.522,0A11.774,11.774,0,0,1,203.111,235.965Zm0-17.651a5.9,5.9,0,0,0-5.89,5.89c.3,7.8,11.485,7.8,11.78,0A5.9,5.9,0,0,0,203.111,218.315Z",
    transform: "translate(-140.286 -140.703)",
    fill: "#0ac9bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86538",
    "data-name": "\\uD328\\uC2A4 86538",
    d: "M148.763,192.481H132.568a2.936,2.936,0,0,1-2.936-2.936v-5.763a27.171,27.171,0,0,1-5.862-3.5l-5.095,2.942a2.935,2.935,0,0,1-4.01-1.074l-8.1-14.025a2.935,2.935,0,0,1,1.074-4.01l5.658-3.266a27.638,27.638,0,0,1,.176-6.018l-5.834-3.368a2.935,2.935,0,0,1-1.074-4.01l8.1-14.025a2.936,2.936,0,0,1,4.01-1.074l6.4,3.693a27.284,27.284,0,0,1,4.561-2.548v-7.471a2.936,2.936,0,0,1,2.935-2.936h16.195a2.936,2.936,0,0,1,2.936,2.936v7.471a27.288,27.288,0,0,1,4.56,2.548l6.4-3.693a2.935,2.935,0,0,1,4.01,1.074l8.1,14.025a2.935,2.935,0,0,1-1.074,4.01l-5.834,3.368a27.656,27.656,0,0,1,.176,6.018l5.658,3.266a2.935,2.935,0,0,1,1.074,4.01l-8.1,14.025a2.935,2.935,0,0,1-4.01,1.074l-5.095-2.942a27.188,27.188,0,0,1-5.862,3.5v5.763A2.936,2.936,0,0,1,148.763,192.481ZM135.5,186.61h10.324v-4.825a2.936,2.936,0,0,1,1.966-2.771,21.448,21.448,0,0,0,7.461-4.473,2.936,2.936,0,0,1,3.453-.38l4.341,2.506,5.162-8.941-4.786-2.763a2.936,2.936,0,0,1-1.433-2.992,21.788,21.788,0,0,0-.256-8.023,2.936,2.936,0,0,1,1.4-3.177l5.076-2.931-5.162-8.941-5.529,3.192a2.936,2.936,0,0,1-3.312-.258,21.487,21.487,0,0,0-6.415-3.574,2.935,2.935,0,0,1-1.966-2.771v-6.533H135.5v6.533a2.936,2.936,0,0,1-1.966,2.771,21.487,21.487,0,0,0-6.415,3.573,2.935,2.935,0,0,1-3.312.258l-5.529-3.192-5.162,8.941,5.076,2.931a2.936,2.936,0,0,1,1.4,3.177,21.782,21.782,0,0,0-.256,8.023,2.936,2.936,0,0,1-1.433,2.992l-4.786,2.763,5.162,8.941,4.341-2.506a2.935,2.935,0,0,1,3.453.38,21.447,21.447,0,0,0,7.461,4.473,2.935,2.935,0,0,1,1.966,2.771v4.825Z",
    transform: "translate(-77.84 -75.137)",
    fill: "#0ac9bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86539",
    "data-name": "\\uD328\\uC2A4 86539",
    d: "M135.786,77.668a2.936,2.936,0,0,0-4.152,0l-6,6v-.238c.7-33.762-29.049-63.513-62.814-62.813C29.063,19.916-.687,49.662.012,83.426c-.7,33.761,29.049,63.512,62.814,62.813a2.935,2.935,0,0,0,0-5.87A57.007,57.007,0,0,1,5.882,83.426c2.86-75.436,111.034-75.419,113.885,0v.238l-6-6a2.936,2.936,0,0,0-4.152,4.152l11.007,11.007a2.953,2.953,0,0,0,4.152,0L135.786,81.82A2.936,2.936,0,0,0,135.786,77.668Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_150744",
    "data-name": "\\uC0AC\\uAC01\\uD615 150744",
    width: 140,
    height: 140,
    transform: "translate(-10734 -4532)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.c731216e29d51ea5fe643d77dc2fc54c.svg";
export { ForwardRef as ReactComponent };